import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IMoment } from '../../interfaces/i-moment';
import { WebappService } from '../../services/webapp.service';
import { ICategory } from '../../interfaces/i-category';
import { IFilter } from '../../interfaces/i-filter';

@Component({
  selector: 'mobo-filter-modal',
  templateUrl: './filter-modal.component.html',
  styles: ``,
})
export class FilterModalComponent implements OnInit {
  @Input() extraClass: string = '';
  @Output() updateFilter = new EventEmitter();
  @Output() filterDone = new EventEmitter();
  public filters: IFilter[] = [];
  public filtersIds: string[] = [];
  public categories: ICategory[] = [];
  public moments: IMoment[] = [];

  private _isOpen: boolean = false;
  public get isOpen(): boolean {
    return this._isOpen;
  }
  public set isOpen(v: boolean) {
    this._isOpen = v;
    if (!v) {
      this.filterDone.emit();
    }
  }

  constructor(public webappService: WebappService) {}

  ngOnInit() {
    this.moments = this.webappService.moments.value;
    this.categories = this.webappService.categories.value;
  }

  public addFilters(filter: IFilter) {
    const isInFilter = this.filters.some((x) => x.id === filter.id);
    if (isInFilter) {
      this.filters = [...this.filters.filter((x) => x.id !== filter.id)];
    } else {
      this.filters = [...this.filters, filter];
    }
    this.filtersIds = this.filters.map((x) => x.id || '');
    this.updateFilter.emit(this.filters);
  }

  public resetFilter() {
    this.filters = [];
    this.filtersIds = [];
  }

  addMoment(moment: IMoment) {
    let filter: IFilter = {
      id: moment.Id,
      description: moment.NameOrigin,
      type: 'MOMENT',
    };
    this.addFilters(filter);
  }

  addCategory(category: ICategory) {
    let filter: IFilter = {
      id: category.Id || category.CategoriesIds,
      description: category.Name,
      type: 'CATEGORY',
    };
    this.addFilters(filter);
  }

  isChecked(id: string = '') {
    return this.filtersIds.includes(id);
  }

  emitFilterDone() {
    this.isOpen = false;
  }
}
